__turbopack_context__.v({
  "button": "pFJqpq_button",
  "invoiceDetails": "pFJqpq_invoiceDetails",
  "item": "pFJqpq_item",
  "itemText": "pFJqpq_itemText",
  "title": "pFJqpq_title",
});
